module.exports = __webpack_public_path__ + "img/plus-circle.376e6237.svg";